import { Injectable } from '@angular/core';

@Injectable()
export class WindowWrapper extends Window {
}
/* istanbul ignore next */
export function windowProvider() { return window; }

